/* eslint-disable react/no-unknown-property */
import { Link } from 'react-router-dom';

export default function Blogsection() {
  return (
   <>
    
    <section>
    <div class="mx-auto">
      <div  class="mt-[6px] text-gray-600 body-font  ">
      <h3 class="text-center lg:text-[22px] font-bold sm:text-3xl"> Our Blogs     </h3>
        </div>
      </div>
 
 
<div className="mt-[-50px] px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
      <div className="grid gap-8 lg:grid-cols-3 sm:max-w-sm sm:mx-auto lg:max-w-full">
        <div className="overflow-hidden transition-shadow duration-300 bg-white rounded shadow-sm">
          <img
            src="https://ik.imagekit.io/sitekitpro/assets/blog/Custom%20Websites.png?updatedAt=1743861833661"
            className="object-cover w-full h-64"
            alt=""
          />
          <div className="p-5 border border-t-0">
            <p className="mb-3 text-xs font-semibold tracking-wide uppercase">
              <a
                href="/"
                className="transition-colors duration-200 text-blue-gray-900 hover:text-deep-purple-accent-700"
                aria-label="Category"
                title="traveling"
              >
               Updated On
              </a>
              <span className="text-gray-600">— March , 2025 </span>
            </p>
            <a
              href="/Blog1"
              aria-label="Category"
              
              className="inline-block mb-3 text-2xl font-bold leading-5 transition-colors duration-200 hover:text-deep-purple-accent-700"
            >
               <h1  className="mx-auto text-left  font-bold lg:text-[13px]  sm:text-xl justify-self-auto " >Your Go-To Solution for Instant Custom Websites  </h1>  
   
            </a>
            
            <p className="mb-1 text-gray-700">
            Explore how SitekitPro revolutionizes website building by offering custom readymade websites within an hour. With its user-friendly interface and rapid setup...
            </p>
           
           
            <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} to="/Blog1" class="mt-4 inline-flex items-center gap-2 rounded border-2 border-indigo-600 bg-orange-500 px-8 py-3 text-white hover:bg-white  hover:text-orange-500 focus:outline-none focus:ring active:text-indigo-500" >
  <span class="text-sm font-medium"> 
Learn More
      </span>

  <svg
    class="h-5 w-5 rtl:rotate-180"
    xmlns="./assets/banners/1.webp"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
   <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
  </svg>
</Link>
 
          </div>
        </div>
        <div className="overflow-hidden transition-shadow duration-300 bg-white rounded shadow-sm">
          <img
            src="https://ik.imagekit.io/sitekitpro/assets/blog/Website%20Building.png?updatedAt=1743861833411"
            className="object-cover w-full h-64"
            alt=""
          />
          <div className="p-5 border border-t-0">
            <p className="mb-3 text-xs font-semibold tracking-wide uppercase">
              <a
                href="/Blog2"
                className="transition-colors duration-200 text-blue-gray-900 hover:text-deep-purple-accent-700"
                aria-label="Category"
               
              >
               Update On 
              </a>
              <span className="text-gray-600">— 12th March , 2025 </span>
            </p>
            <a
              href="/Blog2"
              aria-label="Category" 
              className="inline-block mb-3 text-2xl font-bold leading-5 transition-colors duration-200 hover:text-deep-purple-accent-700"
            >
             <h1  className="mx-auto text-left  font-bold lg:text-[13px]  sm:text-xl justify-self-auto " >Effortless Website Setup with SitekitPro and WordPress Integration </h1>  
            </a>
            <p className="mb-1 text-gray-700">
            Discover the seamless integration of SitekitPro with WordPress and the latest technologies for building dynamic websites in a snap...
            </p>
            <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} to="/Blog2" class="mt-4 inline-flex items-center gap-2 rounded border-2 border-indigo-600 bg-orange-500 px-8 py-3 text-white hover:bg-white  hover:text-orange-500 focus:outline-none focus:ring active:text-indigo-500" >
  <span class="text-sm font-medium"> 
Learn More
      </span>

  <svg
    class="h-5 w-5 rtl:rotate-180"
    xmlns="./assets/banners/1.webp"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
   <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
  </svg>
</Link>
 
          </div>
        </div>
        <div className="overflow-hidden transition-shadow duration-300 bg-white rounded shadow-sm">
          <img
            src="https://ik.imagekit.io/sitekitpro/assets/blog/Website%20Setup.png"
            className="object-cover w-full h-64"
            alt=""
          />
          <div className="p-5 border border-t-0">
            <p className="mb-3 text-xs font-semibold tracking-wide uppercase">
              <a
                href="/"
                className="transition-colors duration-200 text-blue-gray-900 hover:text-deep-purple-accent-700"
                aria-label="Category"
                title="traveling"
              >
                Updated On 
              </a>
              <span className="text-gray-600">— March , 2025 </span>
            </p>
            <a
              href="/Blog3"
              aria-label="Category" 
              className="inline-block mb-3 text-2xl font-bold leading-5 transition-colors duration-200 hover:text-deep-purple-accent-700"
            >
             <h1  className="mx-auto text-left  font-bold lg:text-[14px]  sm:text-xl justify-self-auto " > Transforming Website Building with Instant Installation </h1>  
             
            </a>
            <p className="mb-2 text-gray-700">
            Learn how SitekitPro streamlines the website building process with easy setup and installation, enabling users to create custom websites..
            </p>
           
            <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }} to="/Blog3" class="mt-4 inline-flex items-center gap-2 rounded border-2 border-indigo-600 bg-orange-500 px-8 py-3 text-white hover:bg-white  hover:text-orange-500 focus:outline-none focus:ring active:text-indigo-500" >
  <span class="text-sm font-medium"> 
Learn More
      </span>

  <svg
    class="h-5 w-5 rtl:rotate-180"
    xmlns="./assets/banners/1.webp"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
   <path stroke-linecap="round" 
   stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
  </svg>
</Link>
            
          </div>
        </div>
      </div>
    </div>

</section><br></br>
   </>
  )
}
 